import { ExtComp, ExtLogger, ExtNotSupportError } from "@hyext-inner/ext-web-comp"
import { HyExtType, HyPostMessageTopic } from "../../util/hy"
import HyExtAdapterInLiveRoom from "../adapters/HyExtAdapterInLiveRoom"
import querystring from 'querystring'

export default class HyExtCompInLiveRoom implements IHyExtCompInLiveRoom {
  extComp:ExtComp
  adapter:HyExtAdapterInLiveRoom
  logger:ExtLogger
  async init (options:HyExtCompInLiveRoomInitOptions) {
    this.extComp = new ExtComp()
    this.adapter = new HyExtAdapterInLiveRoom(options)
    this.logger = ExtLogger.getGlobalLogger(logContent => this.adapter.log(logContent))
    this.logger.info('欢迎使用虎牙小程序，努力初始化中...')
    try {
      this.logger.debug('中台小程序组件初始化')
      await this.extComp.init(this.adapter)
      this.logger.debug('拉取小程序列表')
      await this.extComp.fetchExtMainList()
      this.logger.debug('中台小程序组件初始化完成', { extMainList: this.extComp.extMainList })
      await this.adapter.extEndpointModulesManager.renderAll(this.extComp.extMainList, this.adapter)
      this.logger.debug('Endpoints初始化完毕', { hyEndpointList: this.adapter.extEndpointModulesManager.extEndpointModuleList })
      this.logger.info('虎牙小程序初始化完成，成功初始化小程序endpoint', { hyEndpointList: this.adapter.extEndpointModulesManager.getSummary() })
    } catch (err) {
      this.logger.warn('虎牙小程序初始化失败', { err: err.message })
      if (process.env.NODE_ENV === 'development') {
        return Promise.reject(err)
      }
    }
  }
  async showPanel(extUuid:string, query:string):Promise<void> {
    const list = this.adapter.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid)
    const endpointModule = list.find(m => m.extEndpoint.extType === HyExtType.WEB_VIDEO_COM)
    if (endpointModule) {
      if (!endpointModule.extFrame.busiFrameLoaded) {
        endpointModule.initBusiFrame(this.adapter, query)
      } else {
        if (query) {
          try {
            // 优先使用json
            endpointModule.postContextMessage(HyPostMessageTopic.ACTIVATED, JSON.parse(query), this.adapter)
          } catch(err) {
            // 报错了，使用querystring
            try {
              endpointModule.postContextMessage(HyPostMessageTopic.ACTIVATED, querystring.parse(query), this.adapter)
            } catch(err) {
              this.logger.warn('showPanel传入的参数既不是json也不是querystring，忽略', { query })
            }
          }
        }
      }
      endpointModule.showPanel(this.adapter)
    } else {
      return Promise.reject(new ExtNotSupportError('没有找到小程序id为' + extUuid + '的web面板类型'))
    }
  }
  async getWebInnerIFrame(extUuid:string):Promise<any> {
    const list = this.adapter.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid)
    const endpointModule = list.find(m => m.extEndpoint.extType === HyExtType.WEB_INNER)
    if (endpointModule) {
      return Promise.resolve(endpointModule.extFrame.iframe)
    } else {
      return Promise.reject(new ExtNotSupportError('没有找到小程序id为' + extUuid + '的全局小程序类型'))
    }
  }
  async loadPopup(extUuid:string, query?:string):Promise<void> {
    const list = this.adapter.extEndpointModulesManager.getExtEndpointModuleListWithExtUuid(extUuid)
    const endpointModule = list.find(m => m.extEndpoint.extType === HyExtType.WEB_POPUP)
    if (endpointModule) {
      if (!endpointModule.extFrame.busiFrameLoaded) {
        endpointModule.initBusiFrame(this.adapter, query)
      } else {
        if (query) {
          try {
            // 优先使用json
            endpointModule.postContextMessage(HyPostMessageTopic.ACTIVATED, JSON.parse(query), this.adapter)
          } catch(err) {
            // 报错了，使用querystring
            try {
              endpointModule.postContextMessage(HyPostMessageTopic.ACTIVATED, querystring.parse(query), this.adapter)
            } catch(err) {
              this.logger.warn('loadPopup传入的参数既不是json也不是querystring，忽略', { query })
            }
          }
        }
      }
    } else {
      return Promise.reject(new ExtNotSupportError('没有找到小程序id为' + extUuid + '的web浮窗类型'))
    }
  }
  async onLocalMessage(extUuid:string, eventName:string, extType:string, handler:(message:string) => void):Promise<void> {
    return this.adapter.onLocalMessage(extUuid, eventName, extType, handler)
  }
  async offLocalMessage(extUuid:string, eventName:string, extType:string, handler:(message:string) => void):Promise<void> {
    return this.adapter.offLocalMessage(extUuid, eventName, extType, handler)
  }
  async postLocalMessage(extUuid:string, eventName:string, extType:string, message:string):Promise<void> {
    return this.adapter.postLocalMessage(extUuid, eventName, extType, message)
  }
}